import FormBody from "./FormBody";

const Form = () => {
  return <FormBody />;
};

export default Form;
